import axios from 'axios'
import Sessions from './sessions/index'
import { capitalize } from '../lib/filters'
import GLOBAL from '../store/actions/global'
import ALERT from '../store/actions/alert'

function graphQLArgs(obj, nested = false) {
  if (typeof obj === 'object' && obj.constructor === Array) return JSON.stringify(obj)
  if (typeof obj === 'string') return JSON.stringify(obj)
  if (typeof obj !== 'object') return obj
  const args = Object.entries(obj).map(([arg, value]) => `${arg}: ${graphQLArgs(value, true)}`).join(', ')
  return nested ? `{ ${args} }` : args
}

function handleHttpError(error) {
  if (error.response) error.responseStatus = error.response.status
  throw error
}

export default class {
  constructor(base, store, referrer) {
    this.base  = base
    this.store = store
    this.axios = axios
    this.referrer = referrer

    this.sessions = new Sessions(this, 'session')
  }

  authToken() {
    if (this._authToken) return this._authToken
    this._authToken = localStorage.getItem('auth-token')
    return this._authToken
  }

  query(query, args, toReturn) {
    this._setGQLHeaders()
    if (args) return this._query2(query, args, toReturn)
    return $GQL.query(query)()
  }

  _query2(query, args, toReturn) {
    const expandedArgs = graphQLArgs(args)
    const fullQuery = `{ ${query} (${expandedArgs}) { ${toReturn} } }`
    return $GQL.query(fullQuery)()
  }

  mutate(mutation, toReturnOrVars, vars) {
    if (vars) return this._mutate2(mutation, toReturnOrVars, vars)
    this._setGQLHeaders()
    return $GQL.mutate(mutation, toReturnOrVars)
  }

  _mutate2(mutation, toReturn, vars) {
    this._setGQLHeaders()
    const fullMutation = `($input: ${capitalize(mutation)}Input!) { ${mutation} (input: $input) { ${toReturn} } }`
    return $GQL.mutate(fullMutation, { input: vars }).then(result => {
      if (result[mutation].hasOwnProperty('errorAttributes')) {
        result[mutation].errorAttributes = JSON.parse(result[mutation].errorAttributes)
      }
      return result[mutation]
    })
  }

  _setGQLHeaders() {
    $GQL.headers({ Authorization: `Bearer ${this.authToken()}`, 'Forkable-Referrer': this.referrer })
  }

  get(path, options) {
    return this.axios.get(`${this.base}/${path}`, this.axiosOptions(options))
      .catch(handleHttpError)
  }

  post(path, data) {
    return this.axios.post(`${this.base}/${path}`, data, this.axiosOptions())
      .catch(handleHttpError)
  }

  put(path, data) {
    return this.axios.put(`${this.base}/${path}`, data, this.axiosOptions())
      .catch(handleHttpError)
  }

  defaultAlert(errors) {
    if (errors && errors[0].hasOwnProperty('message')) {
      this.store.dispatch(ALERT.SHOW, { content: errors.map(e => e.message).join(', '), variant: 'danger' })
    } else if (Array.isArray(errors)) {
      this.store.dispatch(ALERT.SHOW, { content: errors.join(', '), variant: 'danger' })
    } else {
      throw errors
    }
  }

  axiosOptions(options) {
    return {
      ...options,
      headers: {
        Authorization: `Bearer ${this.authToken()}`,
      },
    }
  }

  static assignErrorsOrThrow(component, e) {
    if (e.responseStatus !== 422) throw e
    component.errors = e.response.data.errors
  }
}
